module.exports = __webpack_public_path__ + "static/img/own-goal.e2e18ad.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/matchInfo/own-goal.svg
// module id = hWR6
// module chunks = 1